export const getStakeholdersByCategory = async (category) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/stakeholders/all?category=${encodeURIComponent(category)}`

        const api = await fetch(url, {
            method: 'GET',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.error('Could not get stakeholders', error)
        return []
    }
}
